import { TabContext, TabPanel } from "@mui/lab";
import { TabLinks } from "components/TabLinks";
import { FeatureFlagKey } from "encamp-shared/src/featureFlags";
import { useBreadcrumb } from "hooks/useBreadcrumbs";
import { useFeatureFlags } from "hooks/useFeatureFlags";
import { useSearchParams } from "react-router-dom";

import { Sse } from "../Sse";
import { ScoutCleanupJobs } from "./ScoutCleanupJobs";
import { ScoutConversations } from "./ScoutConversations";
import { ScoutDashboard } from "./ScoutDashboard";
import { ScoutEvals } from "./ScoutEvals";
import { ScoutLoadTest } from "./ScoutLoadTest";
import { ScoutLocks } from "./ScoutLocks";
import { ScoutNodes } from "./ScoutNodes";

const DASHBOARD_TAB = "/staff/observe";
const LOAD_TEST_TAB = "/staff/observe?tab=load-test";
const SCOUT_NODES_TAB = "/staff/observe?tab=scout-nodes";
const SCOUT_LOCKS_TAB = "/staff/observe?tab=scout-locks";
const SCOUT_CLEANUP_JOBS_TAB = "/staff/observe?tab=scout-cleanup-jobs";
const SCOUT_CONVERSATIONS_TAB = "/staff/observe?tab=scout-conversations";
const BENCHMARKS_TAB = "/staff/observe?tab=benchmarks";
const SSE_TAB = "/staff/observe?tab=sse";

function getSelectedTabValue(tabParam: string | null): string {
  if (tabParam === "load-test") {
    return LOAD_TEST_TAB;
  }
  if (tabParam === "scout-nodes") {
    return SCOUT_NODES_TAB;
  }
  if (tabParam === "scout-locks") {
    return SCOUT_LOCKS_TAB;
  }
  if (tabParam === "scout-cleanup-jobs") {
    return SCOUT_CLEANUP_JOBS_TAB;
  }
  if (tabParam === "scout-conversations") {
    return SCOUT_CONVERSATIONS_TAB;
  }
  if (tabParam === "benchmarks" || tabParam === "scout-evals") {
    return BENCHMARKS_TAB;
  }
  if (tabParam === "sse") {
    return SSE_TAB;
  }
  return DASHBOARD_TAB;
}

export function Observe() {
  useBreadcrumb({ label: "Observe" });

  const [searchParams] = useSearchParams();
  const { featureFlags } = useFeatureFlags();
  const selectedTabVal = getSelectedTabValue(searchParams.get("tab"));

  const tabs = [
    {
      title: "Dashboard",
      to: DASHBOARD_TAB,
      component: <ScoutDashboard />,
    },
    {
      title: "Scout Load Test",
      to: LOAD_TEST_TAB,
      component: <ScoutLoadTest />,
    },
    {
      title: "Scout Nodes",
      to: SCOUT_NODES_TAB,
      component: <ScoutNodes />,
    },
    {
      title: "Scout Locks",
      to: SCOUT_LOCKS_TAB,
      component: <ScoutLocks />,
    },
    {
      title: "Scout Cleanup Jobs",
      to: SCOUT_CLEANUP_JOBS_TAB,
      component: <ScoutCleanupJobs />,
    },
    {
      title: "Scout Conversations",
      to: SCOUT_CONVERSATIONS_TAB,
      component: <ScoutConversations />,
    },
    {
      title: "Evals",
      to: BENCHMARKS_TAB,
      component: <ScoutEvals />,
    },
    ...(featureFlags[FeatureFlagKey.Sse]
      ? [
          {
            title: "SSE",
            to: SSE_TAB,
            component: <Sse />,
          },
        ]
      : []),
  ];

  return (
    <TabContext value={selectedTabVal}>
      <TabLinks tabs={tabs} value={selectedTabVal} scrollable aria-label="Observe tabs nav" />
      {tabs.map((tab) => (
        <TabPanel key={tab.to} value={tab.to} sx={{ px: 0 }}>
          {tab.component}
        </TabPanel>
      ))}
    </TabContext>
  );
}
